export function isEmpty(str) {
		return (typeof str !== "undefined" && str !== null && str !== "") ? false : true;
	} 
	
export function ContentFilter() {
		var contentFilters = document.getElementsByClassName("content-filter");
		[].forEach.call(contentFilters, function(contentFilter) {
			var targetSelector = contentFilter.getAttribute("data-filter-content");
			var target = document.getElementById(targetSelector);
			if(!isEmpty(target)) {
				var contentFilterData = {
					current: {
						filter: null,
						trigger: null
					},
					list: []
				}
				
				contentFilterData.list = target.querySelectorAll("[data-filter-item]");
				
				contentFilter.addEventListener("click", function(event) {
					event.preventDefault();
					if (event.target.hasAttribute("data-filter")) {
						var targetFilter = event.target.getAttribute("data-filter");
						if(!isEmpty(targetFilter) && targetFilter != contentFilterData.current.filter) {
							if (contentFilterData.current.trigger != null) {
								contentFilterData.current.trigger.classList.remove("is-active");
							}
							
							event.target.classList.add("is-active");
							contentFilterData.current.trigger = event.target;
							contentFilterData.current.filter = targetFilter;
							
							filterList(targetFilter);
						}
					}
				});
				
				function filterList(targetFilter) {
					[].forEach.call(contentFilterData.list, function(filterItem) {
						if (targetFilter == "all" || filterItem.classList.contains("filter-"+targetFilter)) {
							filterItem.classList.remove("filter-hide");
						} else {
							filterItem.classList.add("filter-hide");
						}
					});
				}
			}
		});
	}